// extracted by mini-css-extract-plugin
module.exports = {"wrapper__preload":"preloader_wrapper__preload__3VPGh","preload":"preloader_preload__3U69H"};